interface Props {
  // value/total used to size the filled portion (0..total)
  value: number;
  total: number;
  // optional segment breakdown (must sum to <= value)
  segments?: { label: string; value: number; color: string }[];
  className?: string;
  height?: number;
}

export default function ProgressBar({
  value,
  total,
  segments,
  className = "",
  height = 10,
}: Props) {
  const pct = total > 0 ? Math.min(100, Math.max(0, (value / total) * 100)) : 0;

  return (
    <div
      className={"relative w-full overflow-hidden rounded-full bg-navy-100 " + className}
      style={{ height }}
      aria-label={`progress ${pct.toFixed(0)}%`}
    >
      {segments && segments.length > 0 ? (
        <div className="absolute inset-0 flex">
          {segments.map((s, i) => {
            const w = total > 0 ? (s.value / total) * 100 : 0;
            return (
              <div
                key={i}
                style={{ width: `${w}%`, background: s.color }}
                title={`${s.label}: ${s.value.toFixed(2)}`}
              />
            );
          })}
        </div>
      ) : (
        <div
          className="absolute inset-y-0 left-0 bg-sea-500"
          style={{ width: `${pct}%` }}
        />
      )}
    </div>
  );
}
